import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EtiquetaMarcopoloModule } from '../etiqueta-marcopolo/etiqueta-marcopolo.module';
import { ModalEtiquetaMarcopoloComponent } from './modal-etiqueta-marcopolo.component';

@NgModule({
  declarations: [
    ModalEtiquetaMarcopoloComponent
  ],
  imports: [
    CommonModule,
    EtiquetaMarcopoloModule,
    ModalModule.forRoot()
  ],
  exports: [
    ModalEtiquetaMarcopoloComponent
  ]
})
export class ModalEtiquetaMarcopoloModule { }
